import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { ActionButton, AddNewFilterWrapper, ColumnHeader, DraggableButton, FilterItem, FilterList, FilterListItem, FiltersColumnWrapper, MarketFilterButton, ResetFilterDesc, ResetFiltersButton } from 'src/components/SportPopup/MarketFilters/MarketFilters.style';
import { List } from 'react-movable';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { FormInputState, FormModel } from 'src_common/common/mobx-utils/Form';
import { apiCommon } from 'src/api/ApiCommon';
import { MarketFiltersState } from 'src/AppState/MarketFiltersState/MarketFiltersState';
import  {DragAndDropIcon } from 'src/assets/icons/DragAndDropIcon';
import {MinusCircleIcon} from 'src/assets/icons/MinusCircleIcon';
import {filtersConfig} from './filters.config';

export class FiltersState {
    public readonly newFilterInput: FormInputState<string>;
    public readonly newFilterInputModel: FormModel<string>;

    public constructor(private readonly marketFiltersState: MarketFiltersState) {
        this.newFilterInput = new FormInputState('', false);
        this.newFilterInputModel = this.newFilterInput.toModel();
    }

    onCreateNewFilter = async (event: React.MouseEvent<HTMLElement>): Promise<void> => {
        event.preventDefault();
        const newFilterName = this.newFilterInput.value.trim();
        if (newFilterName !== '') {
            const newFilterSlug = newFilterName.toLowerCase().split(' ').join('_');
            const lastFilterInSport = [...this.marketFiltersState.getFiltersForSport].pop();
            const displayOrder = lastFilterInSport !== undefined ? lastFilterInSport.display_order + 1 : 0;

            this.newFilterInput.reset();

            try {
                await apiCommon.marketFiltersAddNewFilter.run({
                    sport_name: this.marketFiltersState.currentSport,
                    filter_name: newFilterName,
                    filter_slug: newFilterSlug,
                    display_order: displayOrder
                });

                await this.marketFiltersState.marketFiltersForSport.get(this.marketFiltersState.currentSport).refresh();
            } catch (error) {
                console.error(error);
            }
        }
    }

    onResetFilters = async (event: React.MouseEvent<HTMLElement>): Promise<void> => {
        event.preventDefault();
        const currentSport = this.marketFiltersState.currentSport;
        const defaultFiltersForSport = filtersConfig[currentSport] ?? [{
            'filter_name': 'Popular',
            'filter_slug': 'popular',
            'display_order': 0,
            'sport_name': currentSport
        },
        {
            'filter_name': 'All markets',
            'filter_slug': 'all_markets',
            'display_order': 1,
            'sport_name': currentSport
        }];

        const data = {
            sportName: currentSport,
            newFilters: defaultFiltersForSport
        };

        await apiCommon.marketFiltersResetFilters.run(data);
        await this.marketFiltersState.marketFiltersForSport.get(currentSport).refresh();
    }
}

interface FiltersPropsType {
    sportName: string
}

export const Filters = observer(({sportName}: FiltersPropsType) => {

    const { marketFiltersState } = useAppStateContext();
    const { getFiltersForSport, selectFilter, selectedFilter, changeFiltersOrderHandler, isLoading, removeFilter } = marketFiltersState.get(sportName);
    const [state] = useState(() => new FiltersState(marketFiltersState.get(sportName)));



    return (
        <FiltersColumnWrapper>
            <ColumnHeader>Filter Display Order</ColumnHeader>
            {
                isLoading ?
                    <h2>Realoading...</h2> :
                    <List
                        lockVertically
                        values={getFiltersForSport}
                        onChange={changeFiltersOrderHandler}
                        renderList={({ children, props, isDragged }): JSX.Element => (<FilterList {...props} style={{cursor: isDragged ? 'grabbing' : 'inherit'}}>
                            {getFiltersForSport.length > 0 ?
                                children :
                                <h2>
                                    There are currently no market filters for this sport
                                </h2>}
                            <AddNewFilterWrapper>
                                <OldInput
                                    formInputState={state.newFilterInput}
                                    model={state.newFilterInputModel}
                                />
                                <MarketFilterButton onClick={state.onCreateNewFilter}>Add new filter</MarketFilterButton>
                            </AddNewFilterWrapper>

                            {
                                getFiltersForSport.length > 0 ?
                                    null :
                                    <div>
                                        <ResetFiltersButton onClick={state.onResetFilters}>RESET to default</ResetFiltersButton>
                                        <ResetFilterDesc>This will set default filters with no market assigned to them</ResetFilterDesc>
                                    </div>
                            }

                        </FilterList>)}
                        renderItem={({ value, props, isDragged }): JSX.Element | null => {
                            return (
                                <FilterListItem {...props} isSelected={selectedFilter?.filter_name === value.filter_name} isDragged={isDragged}>
                                    <DraggableButton
                                        data-movable-handle
                                        style={{
                                            cursor: isDragged ? 'grabbing' : 'grab'
                                        }}
                                        tabIndex={-1}
                                    >
                                        <DragAndDropIcon />
                                    </DraggableButton>
                                    <FilterItem  onClick={() => selectFilter(value)} >
                                        {value.filter_name}
                                        {value.filter_slug !== 'all_markets' || (value.filter_slug === 'all_markets' && getFiltersForSport.length === 1) ? <ActionButton onClick={() => removeFilter(value.id)}> <MinusCircleIcon /> </ActionButton> : null}
                                    </FilterItem>
                                </FilterListItem>);
                        }}
                    />
            }

        </FiltersColumnWrapper>
    );
});
